import { render, staticRenderFns } from "./PaymentMethodSelector.vue?vue&type=template&id=260b2297&scoped=true"
import script from "./PaymentMethodSelector.vue?vue&type=script&lang=js"
export * from "./PaymentMethodSelector.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodSelector.vue?vue&type=style&index=0&id=260b2297&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260b2297",
  null
  
)

export default component.exports